import React, { useState, useEffect } from 'react';
import IsLgScreen from './IsLgScreen'
import IsMobileScreen from './IsMobileScreen'
import { Toaster } from '@/components/ui/sonner';
import MinimalHome from './MinimalHome';

export default function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280); // Adjust breakpoint as needed
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <section>
      {/* {isMobile ? <IsMobileScreen /> : <IsLgScreen />} */}
      <MinimalHome />
      <Toaster />
    </section>
  )
}
